module.exports = __webpack_public_path__ + "static/image/history/m/201605@3x.ver2_0_2.jpg?d220bf1f";